<template>
  <div class="accordion-container">
    <p class="accent">{{ t('label_image_setting') }}</p>

    <Info2Column :title="t('label_chatroom_entry_bg_image')">
      <div class="image-uploader-wrapper">
        <ImageUploader :initial-preview-url="entranceImageUrl" @file-selected="entranceFileSelected" />
        <p class="small-comment small mt-5">
          {{ t('alert_logo_fallback') }}
        </p>
      </div>
    </Info2Column>

    <Info2Column :title="t('label_chatroom_logo_image')" class="iu-2">
      <div class="image-uploader-wrapper">
        <ImageUploader :initial-preview-url="callImageUrl" @file-selected="callFileSelected" />
        <p class="small-comment small mt-5">
          {{ t('guide_image_screen_chat') }}
        </p>
      </div>
    </Info2Column>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import ImageUploader from '@/components/shared/composite/ImageUploader.vue';
import Info2Column from '@/components/shared/composite/Info2Column.vue';

const { t } = useI18n();

defineProps<{
  entranceImageUrl: string | null;
  callImageUrl: string | null;
}>();

const emit = defineEmits<{
  (e: 'entrance-file-selected', file: File | null): void;
  (e: 'call-file-selected', file: File | null): void;
}>();

const entranceFileSelected = (file: File | null) => {
  emit('entrance-file-selected', file);
};

const callFileSelected = (file: File | null) => {
  emit('call-file-selected', file);
};
</script>

<style lang="scss" scoped>
.image-uploader-wrapper {
  align-items: center;
  width: 100%;
  gap: 1rem;
}
:deep(.content-wrapper) {
  .title {
    justify-content: center;
    font-weight: 500;
  }
}
.accordion-container {
  border-top: 1px solid $color-gray-40;
  padding-top: 2.5rem !important;

  .iu-2 {
    margin-top: 2rem;
    padding-top: 2rem;
    border-top: 1px solid $color-gray-40;
  }
  .image-uploader-wrapper {
    .small-comment {
      text-align: center;
    }
  }
}
</style>
